import { render, staticRenderFns } from "./ChairmansDetail.vue?vue&type=template&id=f8b5cb4c&scoped=true&"
import script from "./ChairmansDetail.vue?vue&type=script&lang=js&"
export * from "./ChairmansDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChairmansDetail.vue?vue&type=style&index=0&id=f8b5cb4c&prod&scoped=true&lang=css&"
import style1 from "./ChairmansDetail.vue?vue&type=style&index=1&id=f8b5cb4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b5cb4c",
  null
  
)

export default component.exports